var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useEffect, useState } from 'react';
import '../../../../api/ConversationResults';
import { PartnerCustomizationContext } from '../../Partners/symptom_check/PartnerCustomizations';
import '../../../clearstep/proto/results_pb';
import { THEME } from '../../../clearstep/util/Theme';
import { getConversationSource } from '../../../../api/Conversation';
import '../../Partners/symptom_check/BasePartner';
var getDollarsString = function (zipCode, sourceOfCare, isTherapistSupported, isAuthenticated, partnerCustomizations) {
    var locationCost = sourceOfCare.locationCost, careDetails = sourceOfCare.careDetails, careType = sourceOfCare.careType;
    var partnerCost = partnerCustomizations.careOptionCost({
        careType: careType,
        careDetails: careDetails,
        zipCode: zipCode,
        isTherapistSupported: isTherapistSupported,
        isAuthenticated: isAuthenticated,
    });
    var cost = partnerCost !== null ? partnerCost : locationCost;
    var dollarsString = typeof cost === 'number' ? '$'.repeat(cost) : null;
    return dollarsString;
};
export var CareOptionCostIcon = function (props) {
    var _a, _b;
    var partnerCustomizations = useContext(PartnerCustomizationContext);
    var costEstimate = props.costEstimate, zipCode = props.zipCode, sourceOfCare = props.sourceOfCare, showCostEstimate = props.showCostEstimate, isTherapistSupported = props.isTherapistSupported, conversationId = props.conversationId;
    var _c = useState(getDollarsString(zipCode, sourceOfCare, isTherapistSupported, false, partnerCustomizations)), dollarsString = _c[0], setDollarsString = _c[1];
    useEffect(function () {
        var checkAuthentication = function () { return __awaiter(void 0, void 0, void 0, function () {
            var resp, ds;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!conversationId) return [3 /*break*/, 2];
                        return [4 /*yield*/, getConversationSource({ conversationId: conversationId })];
                    case 1:
                        resp = _b.sent();
                        if (resp && ((_a = resp.data) === null || _a === void 0 ? void 0 : _a.isAuthenticated)) {
                            ds = getDollarsString(zipCode, sourceOfCare, isTherapistSupported, resp.data.isAuthenticated, partnerCustomizations);
                            setDollarsString(ds);
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        checkAuthentication();
    }, [conversationId]);
    var careOptionCostIconStyling = 'text-grass w-24 text-right text-2.5xl leading-9 font-bold mobile:hidden';
    // Show the exact $ amount if we have the data & in cost estimate mode
    if (showCostEstimate && ((_a = costEstimate === null || costEstimate === void 0 ? void 0 : costEstimate.data) === null || _a === void 0 ? void 0 : _a.totalCost)) {
        return (React.createElement("span", { className: careOptionCostIconStyling }, 
        // eslint-disable-next-line react/jsx-no-literals
        "$".concat((_b = costEstimate === null || costEstimate === void 0 ? void 0 : costEstimate.data) === null || _b === void 0 ? void 0 : _b.totalCost.toFixed(0))));
    }
    // Show $$ repeated unless the partner hides this
    if (!THEME.symptomCheckCustomizations.hideCareOptionsCost) {
        return React.createElement("span", { className: careOptionCostIconStyling }, dollarsString);
    }
    // Or else show an empty span with styles for spacing
    return React.createElement("span", { className: careOptionCostIconStyling });
};
export default CareOptionCostIcon;
